<script>
import request from '@/services/request'
import { mapActions } from 'vuex';
import Catalogue from '@/services/catalogue';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    data() {
        return {
			catalogue: new Catalogue(),
            search: {
                user_id: '',
                department_id: '',
                tenant_id: '',
            },
            tenants: [],
            errors: {},
            tenant: {
                id: '',
            },
            pays: []
        }
    },
    methods: {        
        getDepartment() {
            this.catalogue.get_departamens_user(this.search.user_id);
            this.search.department_id = '';
            this.search.tenant_id = '';
        },
        async getTenants() {
            let vm = this;
            if(this.search.department_id && this.search.user_id){
                let search = {
                    user_id: this.search.user_id,
                    department_id: this.search.department_id,
                };
                
                let _endpoint = '/contracts_user';
                try {
                    let { data } = await request.get(_endpoint, search)
                    if (data) {
                        console.log(data);
                        vm.tenants = data;
                    }
                } catch (error) {
                    console.log(error);
                }
            }else{
                this.tenants = [];
            }
        },
        getTenant(){
            if(this.search.tenant_id){
                this.tenant.id = this.search.tenant_id;
                this.list();
            }
        },
        closedModal() {
            this.pays = [];
            this.tenant = {};

            this.search.department_id = '';
            this.search.tenant_id = '';
            this.search.user_id = '';
            this.tenants = [];
            this.errors = {};

            Event.$emit('event-load-tenants');
            this.$modal.hide('ListServicesExtrasAll');
        },        
        async list() {
            let vm = this;
            if(this.tenant.id){
                this.pays = [];
                let service = request;
                let _endpoint = '/contract_dues_extras?id=' + this.tenant.id;
                try {
                    let { data } = await service.get(_endpoint)
                    if (data) {
                        console.log(data);
                        vm.pays = data;
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        },
        async saveAll() {
            let _endpoint = '/contract_dues_extras?id=' + this.tenant.id;
            let data_form = {
                services: this.pays
            };
            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    Event.$emit('event-load-contract_dues');
                    this.closedModal();
                    this.successNotification(data);
                }
            } catch (error) {
                console.log(error);
            }
        },
        addServices() {
            let service = {
                id: '',
                service_id: null,
                contract_due_id: this.tenant.id,
                base_amount: 0,
                description: '',                
            };
            this.pays.push(service);
        },
        deleteServices(index) {
            this.$swal({
                title: 'Eliminar servicio',
                text: 'Se eliminar el servicio',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        this.pays.splice(index, 1);

                        this.successNotification('Se elimino correctamente, asegúrate de guardar');
                    } catch (error) {
                        this.errors = await this.errorNotification(error)
                    }
                }
            });
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    mounted() {
        this.catalogue.get_users_profile(7);
    },
    created() {
        Event.$on("event-list-extra-services-all", () => {
            this.$modal.show('ListServicesExtrasAll');
        });
    },
    computed: {
        totalAmount() {
            return this.pays.reduce((sum, pay) => {
                const amount = parseFloat(pay.amount || 0);
                return pay.negative == 1 ? sum - amount : sum + amount;
            }, 0);
        }      
    },
    watch: {
        pays: {
            handler(newPays) {
                newPays.forEach(pay => {
                    pay.amount = parseFloat(pay.base_amount || 0);
                });
            },
            deep: true
        }
    }
}
</script>
<template>
    <modal name="ListServicesExtrasAll" :width="'80%'" :scrollable="true" :maxHeight="300" :height="'auto'">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Lista de pagos</h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-4">
                    <label>Cliente :</label>
                    <select class="form-control" v-model="search.user_id" @change="getDepartment()">
                        <option value="">Todas</option>
                        <option :value="user.id" v-for="(user, user_index) in catalogue.users_profile"
                            :key="user_index">{{ user.name }} {{ user.last_name }}</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label> Indiviso :</label>
                    <select class="form-control" v-model="search.department_id" @change="getTenants()">
                        <option value="">Sin indiviso </option>
                        <option :value="company.id" v-for="(company, index) in catalogue.departamens_user"
                            :key="index">
                            {{ company.name }}
                        </option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label>Periodo :</label>
                    <select class="form-control" v-model="search.tenant_id" @change="getTenant()">
                        <option value="">Sin periodo</option>                      
                        <option :value="tenant.id" v-for="(tenant, index) in tenants"
                            :key="index">
                            {{ tenant.due_date | toDateTime }}
                        </option>
                    </select>
                </div> 
                <div class="col-12 mt-3">
                    <div class="table-responsive">
                        <table class="table table-bordered text-center text-sm">
                            <thead>
                                <tr>
                                    <th>Nombre</th>                                   
                                    <th>Total</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody v-if="pays.length > 0">
                                <tr v-for="(pay, index) in pays" :key="index">                                 
                                    <td>
                                        <input :disabled="!prop_edit" class="form-control form-control-sm"
                                            v-model="pay.description">
                                    </td>                                
                                    <td>
                                        <money :disabled="!prop_edit" class="form-control form-control-sm"
                                            v-model="pay.base_amount"></money>
                                    </td>
                                    <td>
                                        <button class="btn btn-sm btn-danger" v-if="prop_edit"
                                            @click="deleteServices(index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td align="center" colspan="3">Sin servicios.</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td >
                                        Total a pagar :
                                    </td>
                                    <td>
                                        {{ totalAmount | toCurrency }}
                                    </td>
                                    <td>
                                    </td>
                                </tr>

                                <tr>
                                    <td colspan="10" align="center">
                                        <button v-if="prop_edit" @click="addServices()"
                                            class="btn btn-sm btn-outline-info">
                                            <i class="fa fa-plus"></i> Servicio
                                        </button>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>

                <div class="col-md-12">
                    <hr>
                    <button v-if="prop_edit" type="button" @click="saveAll()"
                        class="btn float-right btn-outline-success">
                        <i class="fas fa-save"></i> Guardar
                    </button>
                    <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                        <i class="fas fa-undo-alt"></i>
                        Regresar
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>